import { User } from './../models/user.model';
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from '../confing';
import { SuccessOautResponse } from '../models/oauth.model';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class OauthService {
  API_BASE = config[config.env].oauth_base_url;
  CLIENT_ID = config[config.env].client_id;
  CLIENT_SECRET = config[config.env].client_secret;
  BASE_URL = config[config.env].base_url;

  constructor(private httpclient: HttpClient) { }
    /**
     * setToken
     * @param token
     */
     public  setToken(token: string) {
      localStorage.setItem('token', token);
  }

  refresh() {
    /* Payload => body di postman */
    const r: SuccessOautResponse = JSON.parse(localStorage.getItem('RefreshToken'));

    const payload = {
        grant_type: 'refresh_token',
        client_id: this.CLIENT_ID,
        client_secret: this.CLIENT_SECRET,
        refresh_token: r.refresh_token,
        scope: ''
    };
    /* Header di postman */
    const header = new HttpHeaders({
         Accept: 'application/json',
        'Content-Type': 'application/json'
    });

    const options = {
        headers: header
    };
    return this.httpclient.post(`${config[config.env].domain}/oauth/token`, payload, options);

}

    public setRefreshToken(successLogin: SuccessOautResponse) {
      localStorage.setItem('RefreshToken', JSON.stringify(successLogin));
      const when = moment().add(successLogin.expires_in, 'seconds').subtract(300, 'seconds');
      localStorage.setItem('when', when.unix().toString());
    }
  /**
   * Remove the token
   *
   */
   public revokeToken(){
        localStorage.removeItem('token');
        localStorage.removeItem('RefreshToken');
   }

  /**
   * setToken
   * @param token
   */
   public  getToken() {
    return localStorage.getItem('token');
  }

  /**
   * logout utente
   */
  logout(){
      const token = this.getToken();
      const header = new HttpHeaders({
          Accept: 'application/json',
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
     });

     const options = {
          headers:header
     };
     this.revokeToken();
    return this.httpclient.delete(`${config[config.env].baseUrl}/logout`,options);
  }
  // tslint:disable-next-line: typedef
  login(userName: string, pwd: string) {
      /* Payload => body di postman */
      const payload = {
          grant_type: 'password',
          client_id: this.CLIENT_ID,
          client_secret: this.CLIENT_SECRET,
          username: userName,
          password: pwd,
          scope: '*'
      };
      /* Header di postman */
      const header = new HttpHeaders({
           Accept: 'application/json',
          'Content-Type': 'application/json'
      });

      const options = {
          headers: header
      };
      return this.httpclient.post(`${config[config.env].domain}/oauth/token`, payload, options);

  }
  /**
   * Get user from api
   * @returns
   */
  getUser() {
      /* Header di postman */
      const token = this.getToken();
      const header = new HttpHeaders({
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
      });

      const options = {
          headers: header
      };

      return this.httpclient.get(`${config[config.env].domain}/api/me`, options);

  }
  /**
   * Save the user on classical local localStorage
   * @param user
   *
   */
  setStorageUser(user: User): void{
      localStorage.setItem('user', JSON.stringify(user));
  }

  clearStorageUser(): void {
      localStorage.removeItem('user');
  }


  /**
   * getUserFromStorage return the user saved on classical localStorage
   * @returns User|null
   */
  getStorageUser(): User|null {
     const key = localStorage.getItem('user');
     return (key) ? JSON.parse(key) : null;
  }

  /**
   *
   * @param pw
   * @returns
   */

  changePwd(pwd: string) {
      const token = this.getToken();
      /* Payload => body di postman */
      const payload = {
          password: pwd
      };
      /* Header di postman */
      const header = new HttpHeaders({
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
      });

      const options = {
          headers: header
      };

      return this.httpclient.post(`${this.BASE_URL}/reset-password`, payload, options);
  }

  /**
   * @param email;
   * @param type;
   * @returns;
   */
  forgotPassword(email: string) {
      const payload = {username : email};
      const header = new HttpHeaders({
          Accept: 'application/json',
          'Content-Type': 'application/json',
      });
      return this.httpclient.post(`${this.BASE_URL}/recovery`, payload, {});
  }
  /**
   * @param pwd
   * @returns
   */
  restorePassword(token: string, pwd: string){
      const payload = {token, pwd};
      const header = new HttpHeaders({
          Accept: 'application/json',
          'Content-Type': 'application/json',
      });
      return this.httpclient.post(`${this.BASE_URL}/restore-password`, payload, {});
  }
}
